import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import {
  type APIResponse,
  type ReportsUserProductivityReportAggregate,
} from "@/lib/types";

export type RetrieveReportsUserProductivityReportInput = {
  dateRange: {
    endDate?: string;
    preset:
      | "ALL_TIME"
      | "TODAY"
      | "PREVIOUS_7_DAYS"
      | "PREVIOUS_30_DAYS"
      | "PREVIOUS_90_DAYS"
      | "YEAR_TO_DATE"
      | "CUSTOM_DATE_RANGE";
    startDate?: string;
  };
  filters: { teamIds?: string[]; userIds?: string[] };
};

export const retrieveReportsUserProductivityReport = async (
  data: RetrieveReportsUserProductivityReportInput,
) => {
  const response = await authenticatedFastApiAxiosInstance.post<
    APIResponse<{
      rows: Array<{
        dailyActivity: Array<{
          actionCounts: Record<string, number>;
          activityDate: string;
          activityHours: number;
          timeline: Array<{ endAt: string; startAt: string }>;
        }>;
        teams: Array<{ label: string }>;
        userId: string;
      }>;
    }>
  >("reports/v2/user-activity/query", {
    ...data,
    pageNumber: 1,
    pageSize: 250,
  });

  return {
    data: response.data.data.rows.flatMap((user) =>
      user.dailyActivity.map(
        (day): ReportsUserProductivityReportAggregate => ({
          userProductivityReportAggregateActionsCompleted: Object.entries(
            day.actionCounts,
          ).map(([action, count]) => ({ [action]: count })),
          userProductivityReportAggregateActivityTotalHours: day.activityHours,
          userProductivityReportAggregateDate: day.activityDate,
          userProductivityReportAggregateMatterTeam: user.teams.map(
            (team) => team.label,
          ),
          userProductivityReportAggregateTimeline: day.timeline.map(
            (range) => ({
              userProductivityReportDateTimeEnd: range.endAt,
              userProductivityReportDateTimeStart: range.startAt,
            }),
          ),
          userProductivityReportAggregateUserId: user.userId,
        }),
      ),
    ),
    meta: response.data.meta,
  } satisfies APIResponse<ReportsUserProductivityReportAggregate[]>;
};
